<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Rate:</label>
        <div>
          <input type="text" placeholder="Rate" v-model="editRate" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading", "propsData"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editName: null,
      editRate: null,
      editId: null,
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.panelTitle = "Add Tech Level";
        this.buttonLabel = "Add Tech Level";
      }
      if (this.editType == "edit") {
        this.panelTitle = "Edit Tech Level";
        this.buttonLabel = "Edit Tech Level";
      }
      this.editName = this.propsData.name;
      this.editRate = this.propsData.rate;
      this.editId = this.propsData.id;
    },
    buttonClick: function () {
      this.$emit(
        "buttonClick",
        this.editName,
        this.editRate,
        this.editType,
        this.editId
      );
    },
  },
};
</script>
